var render, staticRenderFns
import script from "./ForeignContractor.vue?vue&type=script&lang=ts&"
export * from "./ForeignContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b4f0d",
  null
  
)

export default component.exports